import * as React from "react";
const SvgPapette = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.9167 7.08333H12.925M8.75 6.25H8.75833M6.25 9.58333H6.25833M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 11.3807 16.3807 12.5 15 12.5H14.5C14.1903 12.5 14.0355 12.5 13.9059 12.5205C13.1928 12.6335 12.6335 13.1928 12.5205 13.9059C12.5 14.0355 12.5 14.1903 12.5 14.5V15C12.5 16.3807 11.3807 17.5 10 17.5ZM13.3333 7.08333C13.3333 7.31345 13.1468 7.5 12.9167 7.5C12.6865 7.5 12.5 7.31345 12.5 7.08333C12.5 6.85321 12.6865 6.66667 12.9167 6.66667C13.1468 6.66667 13.3333 6.85321 13.3333 7.08333ZM9.16667 6.25C9.16667 6.48012 8.98012 6.66667 8.75 6.66667C8.51988 6.66667 8.33333 6.48012 8.33333 6.25C8.33333 6.01988 8.51988 5.83333 8.75 5.83333C8.98012 5.83333 9.16667 6.01988 9.16667 6.25ZM6.66667 9.58333C6.66667 9.81345 6.48012 10 6.25 10C6.01988 10 5.83333 9.81345 5.83333 9.58333C5.83333 9.35321 6.01988 9.16667 6.25 9.16667C6.48012 9.16667 6.66667 9.35321 6.66667 9.58333Z",
      stroke: "#131A29",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgPapette;
